import { useTranslation } from 'react-i18next';
import { TableSegment } from '@anytag/shared-atoms';
import { FilterAction } from '@anytag/shared-types';
import { AffiliateReportShowBy, AutoManagedReportSummary } from '@anytag/graphql';
import { AutoManagedReportFilterFormValues } from '../schemaTypes';
import { AutoManagedReportByDateTable } from './AutoManagedReportByDateTable';
import { AutoManagedReportByInfluencerTable } from './AutoManagedReportByInfluencerTable';

interface AutoManagedReportTableProps extends FilterAction<AutoManagedReportFilterFormValues> {
  currency: string;
  campaignId: number;
  summaryData?: AutoManagedReportSummary;
}

export const AutoManagedReportTable = ({
  filter,
  currency,
  setFilter,
  campaignId,
  summaryData
}: AutoManagedReportTableProps) => {
  const { t } = useTranslation();

  const isShowByDate = filter.mode === AffiliateReportShowBy.DATE;
  const defaultTableProps = { currency, campaignId, summaryData };

  return (
    <>
      <TableSegment
        type="radio"
        values={[filter.mode]}
        className="report-table-segment"
        onChange={(mode) => setFilter({ mode })}
        options={[
          { value: AffiliateReportShowBy.DATE, label: t('Show by date') },
          { value: AffiliateReportShowBy.INFLUENCER, label: t('Show by Influencer') }
        ]}
      />

      {isShowByDate ? (
        <AutoManagedReportByDateTable {...defaultTableProps} />
      ) : (
        <AutoManagedReportByInfluencerTable {...defaultTableProps} />
      )}
    </>
  );
};
